import React, {Component} from 'react';
import {
    Carousel,
    Comment,
    message,
    Button,
    Icon,
    Avatar,
    Timeline,
    Menu,
    Spin,
    Card,
    Layout,
    notification,BackTop
} from 'antd';

import './App.css';

import sonLogo from './son.png';

import benLogo from './ben.png';

import cmsLogo from './cms.png';

import anshorLogo from './anshor.jpeg';


import userLogo from './user.png';

import headerVideo from './header.mp4';

import headerLogo from './header.png';

const {
    Header, Content, Footer, Sider,
  } = Layout;
  
const {Meta} = Card;
class App extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            route: 'home'
        }
    }

    componentDidMount() {
        document.getElementsByClassName('section-99')[0].click()
        document.getElementsByClassName('section-99')[0].click()
        message
            .loading('Loading A/I Developer..', 1.5)
            .then(() => {
                message.success(
                    <span><Avatar
                    src={anshorLogo}
                    alt="Anshor"/>
                    Ahsanul Intishor</span>, 0)
                message.info('Open for Remote', 2)
                this.setState({loading: false});
                this.refs.backVideo.autoplay = true;

            });

            notification.open({
                message: <span>Created with <Icon type="heart" style={{ color: 'pink' }}/> </span>,
                description: 'Using ReactJS and served on Github Pages',
                duration: 5,
                icon: <Icon type="smile" style={{ color: '#108ee9' }} />,
                onClick: () => {
                  console.log('Notification Clicked!');
                },
              });
    }
    render() {
        const {loading, route} = this.state;
        console.log(route)
        const MenuTop = 
        <Layout>
                <Sider breakpoint="lg" collapsedWidth="0">
                    <header className="App-header"><Menu mode="horizontal">
            {route === 'portofolio' && <Menu.Item key="main">
                <Button
                    type="primary"
                    onClick={() => {
                    this.setState({route: 'home'})
                }}>Home</Button>
            </Menu.Item>}
            {route === 'home' && <Menu.Item key="portofolio">
                <Button
                    type="primary"
                    onClick={() => {
                    this.setState({route: 'portofolio'})
                }}>Portofolio</Button>
            </Menu.Item>}
            <Menu.Item key="mail">
                <span><Icon type="mail"/>
                    <a href="mailto:auronsanjr@gmail.com">Contact Me</a>
                </span>
            </Menu.Item>
            <Menu.Item key="linkedin">
                <span><Icon type="linkedin"/>
                    <a
                        href="https://www.linkedin.com/in/auronsan/"
                        target="_blank"
                        rel="noopener noreferrer">Linkedin</a>
                </span>
            </Menu.Item>
        </Menu>
        </header>
        </Sider>
        </Layout>
        if (route === 'home') {

            return (
                <div className="App">
                        {MenuTop}
                    <section className="section-0" style={{backgroundImage: "linear-gradient(black,#000000),url("+headerLogo+")"}}>
                    {loading &&<Spin size="large"/>}
                    {!loading &&<div ><h1 className="section-0__top text-align-center">Let's build something amazing together</h1>
                    <h2 className="section-0__top-2 text-align-center">I'm here to create meaningful and lasting relationships with my clients.<br/>
                    <Button type="primary" className="buttonGithub" size="large"><a class="github-button" href="https://github.com/auronsan" aria-label="Follow @auronsan on GitHub"><Icon type="github" style={{color:"black"}}/> @auronsan</a></Button>
             </h2>
                    </div>
                    }
                    
                    
                    </section>
                    <section className="section-99">
                    {loading &&<Spin size="large"/>}
                    {!loading &&<div id="player" >
                    <video ref="backVideo" className="background-video ready" id="playerBackground" controls=""  preload="auto" autoPlay="autoplay" loop muted>
                    <source src={headerVideo} type="video/mp4"/>
                    </video>
                    </div>
                     }
                    </section>
               

                    {loading && <section className="bodyContent section-1">
                        <div>
                            <Timeline pending="Loading..."></Timeline>
                        </div>
                    </section>}

                    <section className="section-2">
                        <div className="section-2__content">
                            <h1 >Full Stack Development (my focus) One For All</h1>
                            
                            {loading && <Spin size="large"/>}
                            {!loading &&<h3 >Let's be honest the current market always changing. With stunning design,
                                fluid, and work plus great architecture of tech stack is one of best option to
                                grasp the market share. Bottom line, that's what I do. And if you want to learn
                                more about working with me, pick up the phone and give me a call (or email).
                            </h3>
                            }
                        </div>
                    </section>
{loading && <section  className="skillsSection">
<div>
<Spin size="large"/>
</div>
</section>}
{!loading &&<section className="skillsSection">
<h2>Experience Skills</h2>
<div className="flexSection">
    <div className="skill-card">
        <header className="skill-card__header"><img
            className="skill-card__icon"
            src="https://upload.wikimedia.org/wikipedia/commons/3/38/HTML5_Badge.svg"
            alt="HTML5 Logo"/></header>
        <section className="skill-card__body">
            <h2 className="skill-card__title">html</h2>
            <span className="skill-card__duration">3+ Years</span>
            <ul className="skill-card__knowledge">
                <li>HTML5</li>
                <li>Semantic HTML</li>
                <li>SVG</li>
                <li>Canvas</li>
            </ul>
        </section>
    </div>
    <div className="skill-card">
        <header className="skill-card__header skill-css"><img
            className="skill-card__icon"
            src="https://cdn-images-1.medium.com/max/1200/1*eXIBeNlLhz4Pe6vDrYkXLQ.png"
            alt="Css Logo"/></header>
        <section className="skill-card__body">
            <h2 className="skill-card__title">CSS</h2>
            <span className="skill-card__duration"> 3+ Years</span>
            <ul className="skill-card__knowledge">
                <li>FlexBox</li>
                <li>Animation</li>
                <li>LESS</li>
                <li>SASS</li>
                <li>BEM</li>
            </ul>
        </section>
    </div>
    <div className="skill-card">
        <header className="skill-card__header skill-javascript"><img
            className="skill-card__icon"
            src="https://png.pngtree.com/svg/20170719/javascript_633988.png"
            alt="Javascript Logo"/></header>
        <section className="skill-card__body">
            <h2 className="skill-card__title">Javascript</h2>
            <span className="skill-card__duration"> 2+ Years</span>
            <ul className="skill-card__knowledge">
                <li>ReactJS</li>
                <li>VanillaJS</li>
                <li>React Native</li>
                <li>NodeJS</li>
                <li>Angular</li>
            </ul>
        </section>
    </div>

    <div className="skill-card">
        <header className="skill-card__header skill-data"><img
            className="skill-card__icon"
            src="https://cdn4.iconfinder.com/data/icons/database/PNG/512/Database_4.png"
            alt="Backend Logo"/></header>
        <section className="skill-card__body">
            <h2 className="skill-card__title">Backend</h2>
            <span className="skill-card__duration"> 2+ Years</span>
            <ul className="skill-card__knowledge">
                <li>PHP</li>
                <li>NodeJS</li>
                <li>Python</li>
                <li>MySQL</li>
                <li>Postgre</li>
                <li>MongoDB</li>
            </ul>
        </section>
    </div>

    <div className="skill-card">
        <header className="skill-card__header skill-other"><img
            className="skill-card__icon"
            src={cmsLogo}
            alt="Other Logo"/></header>
        <section className="skill-card__body">
            <h2 className="skill-card__title">Other</h2>
            <span className="skill-card__duration"> 2+ Years</span>
            <ul className="skill-card__knowledge">
               <li>Wordpress</li>
               <li>Oxwall</li>
                <li>Drupal</li>
                <li>CMS</li>
                <li>ReactXP</li>
                <li>ReactVR</li>
            </ul>
        </section>
    </div>
    
    
</div>
</section>
}
                    <section className="comment-section">
                        <h2 >People that already I work for</h2>
                        <div className="comment-section__content">
                        <Comment
                            author={<div> Son(PO < a href = "https://vietnamworks.com" > Vietnamworks </a>)<Icon type="heart" theme="twoTone" twoToneColor="#eb2f96" /> </div>}
                            avatar={(<Avatar
                            src={sonLogo}
                            alt="Han Solo"/>)}
                            content={(
                            <p>All-round player with excellent coding skill. Bringing New tech on our
                                company. Fun Person, got so much feedback from him to solve current problem</p>
                        )}/>
                        <Comment
                            author={<div> Ben(PO < a href = "https://our.group" > Our.Group </a>) <Icon type="smile" theme="twoTone" /> </div>}
                            avatar={(<Avatar
                            src={benLogo}
                            alt="Han Solo"/>)}
                            content={(
                            <p>Wondeful Developer, can implement from idea to application.
                            never doubt his skill to implement new tech.
                            prototypes beautifully and efficiently. </p>
                        )}/>
                        <Comment
                            author={<div> Wallie(Tech Lead < a href = "https://wegen-energy.com" > Wegen Energy </a>) <Icon type="smile" theme="twoTone" /> </div>}
                            avatar={(<Avatar
                            src={userLogo}
                            alt="Han Solo"/>)}
                            content={(
                            <p>Work together to implement IOT from Solar Power meter to usable mobile application.
                                great fluid, send realtime data, and robust with AWS IOT + DynamoDB.
                            </p>
                        )}/>
                        </div>
                    </section>
                    
                    

  <footer className="footer">
  <span className="footer__content-1">Get a application that looks amazing and actually works.</span>
<span className="footer__content-2">© 2019 Ahsanul Intishor. All rights reserved. Full Stack Developer</span>

  </footer><BackTop />
                </div>
            );
        }
        if (route === 'portofolio') {
            return <div className="App">
                
                    {MenuTop}
                {!loading && <section className="bodyContent section-1">
                    <div>
                        <h2>Working Experiences</h2>
                        <Timeline pending="Searching Happy Client.." reverse>
                            <Timeline.Item color="red">
                                <p>
                                    <a href="https://kuboseinz.co" target="_blank" rel="noopener noreferrer">Kuboseinz.co</a>
                                </p>
                                <p>
                                    Junior Developer</p>
                            </Timeline.Item>
                            <Timeline.Item color="red">
                                <p>
                                    <a href="https://our.group" target="_blank" rel="noopener noreferrer">Our.group</a>
                                </p>
                                <p>
                                    Developer : JS,CSS,PHP</p>
                            </Timeline.Item>
                            <Timeline.Item color="red">
                                <p>
                                    <a href="https://wegen-energy.com" target="_blank" rel="noopener noreferrer">Wegen Energy</a>
                                </p>
                                <p>
                                    Full Stack Developer : JS,HTML5,CSS, NodeJS</p>
                            </Timeline.Item>

                            <Timeline.Item color="red">
                                <p>
                                    <a href="https://doctor.help" target="_blank" rel="noopener noreferrer">Doctor.help
                                    </a>
                                </p>
                                <p>
                                    Full Stack Developer : JS,HTML5,CSS, Python</p>
                            </Timeline.Item>

                            <Timeline.Item>
                                <p>
                                    <a href="https://vietnamworks.com" target="_blank" rel="noopener noreferrer">Vietnamworks.com</a>
                                </p>
                                <p>
                                    Full Stack Developer : JS,HTML5,CSS, PHP, Python, Golang</p>
                            </Timeline.Item>

                        </Timeline>
                    </div>
                </section>}
                <secion>
                </secion>
            </div>
        }

        return <div>No Route</div>
    }
}

export default App;
